import { NonIdealState } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';

const PersonCardError = ({ className, message }) => (
  <NonIdealState
    className={className}
    description={message}
    icon="error"
    title="Something went wrong"
  />
);

PersonCardError.defaultProps = {
  className: undefined,
  message: undefined,
};

PersonCardError.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
};

export default PersonCardError;
